<template lang="pug">
.paid-plan-ads-modal
  b-modal(v-model="_value" size="lg" hide-header no-close-on-backdrop no-close-on-esc @ok="ok")
    .default-modal-body
      .messages.mb-3
        span 現在、無料プランが選択されています。一部の機能ボタンは選択不可になっています。
        br
        strong 有料プランでは、以下の機能が使用可能
        span です。ぜひご検討ください。

      .function-list
        ul
          li
            .title
              span 写真・動画の配信
            .descriptions 家族への連絡機能で、写真・動画を添付して配信可能。
          li
            .title
              span アンケート
            .descriptions ご家族や施設関係者（職員様など）にアンケートが可能。質問の作成や回答集計も簡単。
          li
            .title 文書送付、同意取得
            .descriptions ご家族への計画書等の文書送付、ご家族からの同意取得が可能。
          li
            .title 外出・外泊届け
              span.new [NEW]
            .descriptions 面会予約と同じように、ご家族から外出・外泊届けの申請が可能。
          li
            .title 利用者グループ管理
            .descriptions ご利用者をフロア等でグループ管理可能。面会日程も利用者グループで異なる日程を作成可能。
          li
            .title 施設関係者（職員様など）との連絡
            .descriptions 施設関係者（職員様など）のLINEに連絡を送信。施設関係者からご施設への連絡も可能。
          li
            .title
              span 安否確認
            .descriptions 施設関係者（職員様など）への安否確認、ご家族への入居者状況等の情報提供が可能。
          li
            .title 医療機関等との情報連携
            .descriptions 医療機関等の他事業所とのメッセージ、ファイル共有が可能。

      .messages
        strong 詳細は「契約プラン確認・変更」よりご確認ください。

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 有料プラン勧誘モーダル
 */
@Component
export default class PaidPlanAdsModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}
</script>

<style lang="scss" scoped>
.messages,
.function-list {
  font-size: 16px;
  .strong {
    font-weight: bold;
  }
}
.function-list {
  .title {
    color: rgba(0, 140, 160, 1) !important;
    font-size: 18px;
    font-weight: bold;
    .new {
      color: rgba(217, 74, 125, 1) !important;
      margin-left: 10px;
    }
  }
  li {
    margin-bottom: 4px;
  }
}
</style>
